module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/pordenone.ae29fd6aba22d8b302c51205f49d0381.jpg";